var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100"},[(_vm.show && _vm.isLyfPayUser)?_c('v-system-bar',{staticClass:"primaryText--text py-4 rounded-b-lg",attrs:{"color":"app"}},[_c('div',{staticClass:"text-center w-100"},[_vm._v(" Votre session expire dans "+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds)+" ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }